import { notification } from 'antd';
import { Notification } from '../@types/notification';

notification.config({
  placement: 'bottomLeft',
  showProgress: true
})

export const notify = (notif: Notification) => {
  notification[notif.type]({
    message: notif.message,
    description: notif.description,
    duration: notif.type === "error" ? 10 : 3
  });
};
